export default __webpack_public_path__ + "static/media/email.c3617f38.svg";